<template>
  <div class="full-page form-page">
    <ui-image :src="book.cover" :timeout="5000" @load-finished="loadFinished = true" v-if="book && book.cover" cover fallback="/img/welcome.jpg">
    </ui-image>
    <div class="book-info-index" v-if="loadFinished">
      <ui-avatar size="sm" :url="book.userInfo.avatar" :username="book.userInfo.username" :show-name="false">{{ book.title }}</ui-avatar>
    </div>
    <ui-container fluid>
      <ui-row align-v="center">
        <ui-col sm="9" md="6" lg="5" offset-sm="2" offset-md="6" offset-lg="6">
          <ui-card>
            <component :is="component" :email="email"></component>
          </ui-card>
        </ui-col>
      </ui-row>
    </ui-container>
  </div>
</template>
<script>
import Login from "../components/form/LoginForm.vue";
import Reg from "../components/form/RegForm.vue";
import ForgotPassword from "../components/form/FindPasswordForm.vue";
import ResetPassword from "../components/form/ResetPasswordForm.vue";
import Activation from "../components/form/ActivationForm.vue";
import Auth from "../components/form/Auth.vue";
import AuthCallback from "../components/form/AuthCallback.vue";
import EmailActivation from "../components/form/ActivationForm.vue";
import api from "../api/index.js";

export default {
  name: "FormPage",

  data() {
    return {
      component: "",
      book: null,
      email: "",
      loadFinished: false
    };
  },
  components: {
    Login,
    Reg,
    ForgotPassword,
    ResetPassword,
    Activation,
    Auth,
    AuthCallback,
    EmailActivation
  },
  mounted() {
    this.component = this.$route.name;
    api.getRandomCover().then(res => {
      if (res.status == 200) {
        this.book = res.data.book;
      }
    });
    if (this.$route.params.email) {
      this.email = window.atob(this.$route.params.email)
    }
  }
};

</script>
<style lang="css" scoped></style>
